import { isAfter } from "date-fns";
import Color from "color";
import { getTimelineSegmentWidth } from "./timelineCellUtils";

export const getTimelineSectionsChartBar = ({
  element,
  blocksStartDate,
  timelineStartDate,
  timelineExpandedMonths,
  maxTimelineEndDate,
  height,
}) => {
  if (!element?.startDay) return {};

  const { offsetLeft, offsetRight, width: barWidth, unmodifiedWidth } = getTimelineSegmentWidth({
    startDate: element.startDay,
    endDate: element.endDate,
    expandedMonths: timelineExpandedMonths,
    includeLastDay: true,
  });

  return {
    color: element.color,
    valueColor: Color(element.color).alpha(0.6).hexa(),
    fontColor: element.fontColor,
    label: element.name,
    height,
    exceeds: maxTimelineEndDate && element.endDate && isAfter(element.endDate, maxTimelineEndDate),
    barLeft: getTimelineSegmentWidth({
      startDate: blocksStartDate ?? timelineStartDate,
      endDate: element.startDay,
      expandedMonths: timelineExpandedMonths,
      isFirstTimelineMonth: !blocksStartDate // && isSameMonth(timelineStartDate, element.startDay),
    }).width,
    barWidth, unmodifiedWidth, offsetLeft, offsetRight,
  };
};
